import type { IconSvgObject } from './types';

const MapsOffIcon: IconSvgObject = [
  ["path", { d: "M8 3.5L8 4.5M8 18L8 8M15 21V15M15 6.00001V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 3.5L7.58517 3.20742C7.84826 3.07587 8.15593 3.06683 8.4263 3.1827L15 6H21C21.5523 6 22 6.44772 22 7V18M21 21H15L8 18L3.31623 19.5613C2.6687 19.7771 2 19.2951 2 18.6126V6.61803C2 6.23926 2.214 5.893 2.55279 5.72361L4.66667 4.66667", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MapsOffIcon;
